
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/badges/season-1",
      function () {
        return require("private-next-pages/badges/season-1.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/badges/season-1"])
      });
    }
  